var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 5.482a93.226 93.226 0 0 0-9.185-.459c-1.815 0-3.63.092-5.445.275l-1.87.184M7.792 4.556l.201-1.201c.147-.871.257-1.522 1.806-1.522h2.402c1.549 0 1.668.688 1.806 1.53l.201 1.193M17.28 8.378l-.597 9.23c-.1 1.44-.183 2.558-2.74 2.558H8.056c-2.557 0-2.64-1.118-2.74-2.557L4.72 8.378M9.47 15.125h3.052M8.708 11.458h4.584",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgTrash as ReactComponent };
export default __webpack_public_path__ + "static/media/trash.7b160e59.svg";